/**
 * Created by lycheng on 2018/11/19.
 */

let envConfig
if(process.env.NODE_ENV !== 'production'){
  envConfig = {
    AUTH_SITE: 'https://ssodev.xfyun.cn/'
  }
}else{
  envConfig = {
    AUTH_SITE: 'https://sso.xfyun.cn/',
  }
}

export {
  envConfig
}


// WEBPACK FOOTER //
// ./app/libs/sso/sso-config.js